import React from "react";
import "./GainsLossesReportWindow.css";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import InGameValueCard from "../InGameValueCard";
import GameData from "../../../gameplay/model/GameData";
import agent from "../../../agent";
import GameController from "../../../gameplay/controllers/GameController";

export default class GainsLossesReportWindow extends React.Component {
    constructor() {
        super();
        this.state = {
            gameData : null
        }
    }
    componentDidMount() {
        let year = GameData.CurrentGame.year - 1;
        year = year > 0 ? year : 0;

        agent.GamePlay.stat(this.props.teamID, year, resp => {
            let data = GameData.CreateGameData(resp);
            this.setState({
                gameData: data
            });
        })
    }

    render() {
        if (!this.state.gameData) return "";

        let gameData = this.state.gameData;
        gameData.uuid = this.props.teamID;
        let stats = GameController.calculateStatistics(gameData);
        let content = <div className="gains-losses__screen">
            <div className="gains-losses__left">
                <InGameValueCard title={"Объем перевезенных грузов (тонны нетто)"} value={stats.totalWeight} height={30} type={0} subtype={0} />

                <InGameValueCard title={"ДОХОДЫ ОТ ПЕРЕВОЗОК + ПРОЧИЕ ДОХОДЫ"} value={stats.profit} height={30} type={0} subtype={0} />

                <InGameValueCard title={"Переменные расходы"} height={30} type={0} subtype={0} />
                    <InGameValueCard title={"Дизтопливо"} value={stats.dieselExpanses} height={20} type={1} subtype={1} />
                    <InGameValueCard title={"Электричество"} value={stats.electricityExpanses} height={20} type={1} subtype={2} />
                    <InGameValueCard title={"Итого переменные расходы"} value={stats.fuelExpanses} height={20} type={1} subtype={0} />

                <InGameValueCard title={"ВАЛОВАЯ ПРИБЫЛЬ"} value={stats.valProfit} height={30} type={0} subtype={0} />

                <InGameValueCard title={"Операционные расходы"} height={30} type={0} subtype={0} />
                    <InGameValueCard title={"Персонал"} value={stats.brigadesExpanses} height={20} type={1} subtype={1} />
                    <InGameValueCard title={"Сверхурочные и подрядчики"} value={stats.contractorsExpenses} height={20} type={1} subtype={2} />
                    <InGameValueCard title={"Материалы для ремонта"} value={stats.partsExpanses} height={20} type={1} subtype={1} />
                    <InGameValueCard title={"Услуги связи"} value={stats.communicationExpanses} height={20} type={1} subtype={2} />
                    <InGameValueCard title={"Прочие операционные расходы"} value={stats.otherExpanses} height={20} type={1} subtype={1} />
                    <InGameValueCard title={"Безопасность"} value={stats.securityExpanses} height={20} type={1} subtype={2} />
                    <InGameValueCard title={"Итого операционные расходы"} value={stats.operationsSum} height={20} type={1} subtype={0} />
            </div>
            <div className="gains-losses__right">
                <InGameValueCard title={"EBITDA"} value={stats.EBITDA} height={30} type={0} subtype={0} />
                <div className="table">
                    <InGameValueCard title={"Амортизация"} value={stats.depreciation} height={30} type={1} subtype={1} />
                </div>

                <InGameValueCard title={"ОПЕРАЦИОННАЯ ПРИБЫЛЬ"} value={stats.operationalProfit} height={30} type={0} subtype={0} />
                <div className="table">
                    <InGameValueCard title={"Проценты по займам"} value={stats.creditPercents} height={30} type={1} subtype={1} />
                </div>

                <InGameValueCard title={"ПРИБЫЛЬ ДО НАЛОГОВ"} value={stats.beforeTaxesProfit} height={30} type={0} subtype={0} />
                <div className="table">
                    <InGameValueCard title={"Налог (30%)"} value={stats.afterTaxesProfit} height={30} type={1} subtype={1} />
                </div>

                <InGameValueCard title={"ЧИСТАЯ ПРИБЫЛЬ"} value={stats.cleanProfit} height={30} type={0} subtype={0} />
                <div className="table">
                    <InGameValueCard title={"Нераспределенная прибыль предыдущего года"} value={stats.lastYearProfit} height={30} type={1} subtype={1} />
                    <InGameValueCard title={"Чистая прибыль"} value={stats.cleanProfit} height={30} type={1} subtype={2} />
                    <InGameValueCard title={"Нераспределенная прибыль этого года"} value={stats.lastYearProfit + stats.cleanProfit} height={30} type={1} subtype={1} />
                </div>
            </div>
        </div> ;

        return <div className="gains-losses container__shadow">
            <div className="gains-losses__content container__content">
                <GameWindowHeader title="отчёт о прибылях и убытках" isClosable={true} onHide={this.props.onHide}
                                  width={1084} height={40}/>
                <div className="gains-losses__body">
                    <GameWindowBg width={1084} height={490} value={content} />
                </div>
            </div>
        </div>
    }
}
